class Accordion {
  constructor(elementOrSelector) {
    this.$root = $(elementOrSelector);
    this.$root.find('.jqAccordion-head').on('click', this.onClickHead.bind(this));
    this.expanding = false;
    this.expanded = false;
  }
  onReady() {
    
  } 
  onLoad() {
  }
  onClickHead(event) {
    if (this.expanding) {
      return;
    }
    const $head = this.$root.find('.jqAccordion-head');
    const $body = this.$root.find('.jqAccordion-body');
    this.expanding = true;
    if (this.expanded) {
      $head.removeClass('is-open');
      $.Velocity($body, {
        height: 0,
        opacity: [0, 1],
      }, {
        duration: 300,
        easing: 'easeInOutQuadad',
      }).then(() => {
        $body.css({
          display: 'none',
          opacity: '',
          height: '',
        });
        this.expanded = false;
        this.expanding = false;
      });
    } else {
      $head.addClass('is-open');
      $body.css({
        display: '',
      });
      const outerHeight = $body.children()
      .map((index, element) => {
        return $(element).outerHeight(true);
      })
      .toArray()
      .reduce((prev, current) => {
        return prev + current;
      });
      $.Velocity($body, {
        height: [outerHeight, 0],
        opacity: [1, 0],
      }, {
        duration: 300,
        easing: 'easeInOutQuadad',
      }).then(() => {
        this.expanded = true;
        this.expanding = false;
      });
    }
  }
}


(() => {
  $.fn.fvAccordion = function plugin() {
    const func = {
      init: ($target) => {
        $target
          .find('.jqAccordion-body')
          .css({
            display: 'none',
          });
      },
      execute: ($target) => {
        new Accordion($target);
      },
    };
    return this.each(function cb() {
      const $target = $(this);
      func.init($target);
      func.execute($target);
    });
  };
})();


// WEBPACK FOOTER //
// ./scripts/autoload/jquery-plugins/Accordion.js